const PATH = 'fe.components.learning_resources.playlist_item';

const messages = {
  resources: {
    key: `${PATH}.resources`,
    defaultValue: 'Resources'
  },
  learningSeries: {
    key: `${PATH}.learningSeries`,
    defaultValue: 'Learning Series'
  },
  complete: {
    key: `${PATH}.complete`,
    defaultValue: 'complete'
  },
  error: {
    key: `${PATH}.error`,
    defaultValue: 'Resource already selected'
  },
  recommend: {
    key: `${PATH}.recommend`,
    defaultValue: 'Recommend'
  }
};

export default messages;
